import type {
  BackgroundBrightness,
  DynamicVariables,
} from './BoardTheme.types';

export const getDynamicNavItemBackgroundColors = (
  backgroundBrightness: BackgroundBrightness,
  isThemeEnabled: boolean,
): Pick<
  DynamicVariables,
  | 'dynamicNavItemBackgroundColorHovered'
  | 'dynamicNavItemBackgroundColorPressed'
> => {
  if (!isThemeEnabled) {
    if (backgroundBrightness === 'dark') {
      return {
        dynamicNavItemBackgroundColorHovered: 'hsla(0, 0%, 100%, 0.16)',
        dynamicNavItemBackgroundColorPressed: 'hsla(0, 0%, 100%, 0.3)',
      };
    } else {
      return {
        dynamicNavItemBackgroundColorHovered: 'hsla(0, 100%, 0%, 0.08)',
        dynamicNavItemBackgroundColorPressed: 'hsla(0, 100%, 0%, 0.16)',
      };
    }
  }

  if (backgroundBrightness === 'dark') {
    return {
      // Equivalent to --ds-background-neutral-subtle-hovered in ADS dark mode:
      dynamicNavItemBackgroundColorHovered: '#A1BDD914',
      // Equivalent to --ds-background-neutral-subtle-pressed in ADS dark mode:
      dynamicNavItemBackgroundColorPressed: '#A6C5E229',
    };
  } else {
    return {
      // Equivalent to --ds-background-neutral-subtle-hovered in ADS light mode:
      dynamicNavItemBackgroundColorHovered: '#091E420F',
      // Equivalent to --ds-background-neutral-subtle-pressed in ADS light mode:
      dynamicNavItemBackgroundColorPressed: '#091E4224',
    };
  }
};
